import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { Card } from "reactstrap";
import { useBeManualFetcher } from "../../../hooks/useBeManualFetcher";
import { useStudentPageContext } from "../../../hooks/useStudentPageContext";
import { studentService } from "../../../services/studentService";
import EventEmitter, { EVENT_TOPICS } from "../../../utilities/eventUtils";
import { appendToFormData } from "../../../utilities/formDataUtils";
import BlockUpdateButton from "../../button/BlockUpdateButton";
import { Block, BlockBetween, BlockTitle } from "../../Component";
import UpdatableText from "../../shared/UpdatabaleText";

const StudentAdminInfoBlock = () => {
  const { id } = useParams();
  const { register, handleSubmit } = useForm();
  const [onFetch] = useBeManualFetcher();
  const { student } = useStudentPageContext();

  const [hasEditClicked, setHasEditClicked] = useState(false);

  function handleOnEditClicked() {
    setHasEditClicked((prev) => !prev);
  }

  async function onFormSubmit(form) {
    const { reply, contractUrl, comment } = form;
    const newFormData = new FormData();

    appendToFormData(newFormData, {
      reply,
      contractUrl,
      comment,
    });

    return await onFetch({
      action: () => studentService.updateStudent(id, newFormData),
      onLoad: (response) => {
        EventEmitter.emit(EVENT_TOPICS.ON_STUDENT_UPDATED, { response });
        handleOnEditClicked();
      },
      successMessage: "Student fields updated successfully",
    });
  }

  return (
    <Card className="card-inner">
      <Block>
        <form onSubmit={handleSubmit(onFormSubmit)}>
          <BlockBetween>
            <BlockTitle tag="h5">Admin Information</BlockTitle>
            <BlockUpdateButton
              hasEditClicked={hasEditClicked}
              handleOnEditClicked={handleOnEditClicked}
            />
          </BlockBetween>
          <div className="profile-ud-list">
            <div className="profile-ud-item mr-5">
              <UpdatableText
                title="Reply"
                defaultValue={student?.reply}
                name={"reply"}
                register={register}
                onEditClicked={hasEditClicked}
                isWider
              />
              <UpdatableText
                title="Contract"
                defaultValue={student?.contractUrl}
                name={"contractUrl"}
                register={register}
                onEditClicked={hasEditClicked}
                isWider
              />
            </div>
            {(student?.hasAgency != null || student?.agencyType) && (
              <div className="profile-ud-item mr-5">
                {student?.hasAgency != null && (
                  <UpdatableText
                    title="Has Agency"
                    defaultValue={student?.hasAgency ? "Yes" : "No"}
                    name={"hasAgency"}
                    isWider
                  />
                )}
                {student?.agencyType && (
                  <UpdatableText
                    title="Agency Type"
                    defaultValue={student?.agencyType}
                    name={"agencyType"}
                    isWider
                  />
                )}
              </div>
            )}
            <div className="profile-ud-item">
              <UpdatableText
                title="Comment"
                defaultValue={student?.comment}
                name={"comment"}
                register={register}
                onEditClicked={hasEditClicked}
                isTextarea
                isWider
                textareaWidth={400}
              />
            </div>
          </div>
        </form>
      </Block>
    </Card>
  );
};

export default StudentAdminInfoBlock;
